import React, { useState } from 'react';
import { ErrorMessage, Field, FieldHookConfig, useField } from 'formik';
import Toggle from '../toggle';
import { BiErrorCircle } from 'react-icons/bi';

interface IProps {
  defaultChecked?: boolean;
  name: string;
  value?: string | boolean;
  valueOne: string;
  valueTwo: string;
  labelOne: string;
  labelTwo: string;
  selectedValue: any;
}

const Radio = ({
  value,
  defaultChecked,
  name,
  labelOne,
  labelTwo,
  valueOne,
  valueTwo,
  selectedValue,
}: IProps & FieldHookConfig<string>) => {
  const [field, meta] = useField('');
  const [selectedOption, setSelectedOption] = useState(selectedValue);
  const handleOptionChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedOption(e.target.value);
  };

  return (
    <>
      <Field component="div" name="myRadioGroup">
        <input
          type="radio"
          checked={valueOne == selectedOption}
          name={name}
          value={valueOne}
          className="mr-2"
          onChange={handleOptionChange}
          // defaultChecked={true}
          id={labelOne}
        />
        <label
          htmlFor={labelOne}
          className=" mr-6 text-sm text-text-black mb-1"
        >
          {labelOne}
        </label>
        <input
          type="radio"
          name={name}
          value={valueTwo}
          id={labelTwo}
          checked={valueTwo == selectedOption}
          onChange={handleOptionChange}
          // defaultChecked={true}
        />
        <label htmlFor={labelTwo} className="ml-2 text-sm text-text-black mb-1">
          {labelTwo}
        </label>
      </Field>
      <div className="relative">
        {meta.touched && meta.error && (
          <BiErrorCircle
            size={17}
            color="#fff"
            className="absolute top-2 mx-2"
          />
        )}

        <ErrorMessage
          component="div"
          name={name}
          className="bg-warning bg-opacity-80 text-pure-white mt-1 text-xs inline-block px-7 py-1 rounded-sm"
        />
      </div>
    </>
  );
};

export default React.memo(Radio);
